import React from 'react'

import Icon from 'common/components/general/Icon'

import './BackNavigation.less'

interface NavigationProps {
  title: string | undefined
  history: any
  path?: string
}

const BackNavigation: React.FC<NavigationProps> = ({ title, history, path }) => {
  const goBack = () => {
    if (path) {
      history.push(path)
    } else {
      history.goBack()
    }
  }

  return (
    <div className="flex flex__space_between_baseline">
      <div className="back_arror cursor_pointer mr-16">
        <Icon type="far fa-arrow-left" fontAwesome onClick={() => goBack()} />
      </div>
      <h4>{title}</h4>
    </div>
  )
}

export default BackNavigation
